import React = require("react");
import { LimaIconProps } from "./DefLimaIconType";

export const LimaIconToolsUsersList = ({
  size = 32, // or any default size of your choice
  color = "black", // or any color of your choice
  title = "", //title
}: LimaIconProps): JSX.Element => {
  return (
    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   viewBox="0 0 24 24"
    //   width={size} // added size here
    //   height={size} // added size here
    //   fill={color} // added color here
    //   aria-labelledby="title"
    // >
    //   <title id="title">{title}</title>
    //   <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" />
    //   <path d="M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0 1 30.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1 0 80 0 40 40 0 1 0-80 0z" />
    // </svg>

    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 33 32.633"
      width={size} // added size here
      height={size} // added size here
      fill={color} // added color here
      aria-labelledby="title"
    >
      <title id="title">{title}</title>
      <g id="Seznam_uživatelu" data-name="Seznam uživatelu" transform="translate(-344.802 -280.755)">
        <g id="Group_13261" data-name="Group 13261" transform="translate(-2.665 -2.766)">
          <g id="Group_13254" data-name="Group 13254" transform="translate(349.802 284.271)">
            <path
              id="Icon_metro-user"
              data-name="Icon metro-user"
              d="M9.4,11.329v-.506a2.74,2.74,0,0,0,1.226-2.279c0-1.524,0-2.76-1.839-2.76S6.951,7.02,6.951,8.544a2.74,2.74,0,0,0,1.226,2.279v.506C6.1,11.5,4.5,12.521,4.5,13.757h8.582C13.081,12.521,11.482,11.5,9.4,11.329Z"
              transform="translate(-4.499 -5.784)"
              fill="none"
              stroke="#8e8e93"
              strokeWidth="1.5"
            />
          </g>
          <g id="Group_13256" data-name="Group 13256" transform="translate(349.802 295.851)">
            <path
              id="Icon_metro-user-2"
              data-name="Icon metro-user"
              d="M9.4,11.329v-.506a2.74,2.74,0,0,0,1.226-2.279c0-1.524,0-2.76-1.839-2.76S6.951,7.02,6.951,8.544a2.74,2.74,0,0,0,1.226,2.279v.506C6.1,11.5,4.5,12.521,4.5,13.757h8.582C13.081,12.521,11.482,11.5,9.4,11.329Z"
              transform="translate(-4.499 -5.784)"
              fill="none"
              stroke="#8e8e93"
              strokeWidth="1.5"
            />
          </g>
          <g id="Group_13257" data-name="Group 13257" transform="translate(349.802 307.431)">
            <path
              id="Icon_metro-user-3"
              data-name="Icon metro-user"
              d="M9.4,11.329v-.506a2.74,2.74,0,0,0,1.226-2.279c0-1.524,0-2.76-1.839-2.76S6.951,7.02,6.951,8.544a2.74,2.74,0,0,0,1.226,2.279v.506C6.1,11.5,4.5,12.521,4.5,13.757h8.582C13.081,12.521,11.482,11.5,9.4,11.329Z"
              transform="translate(-4.499 -5.784)"
              fill="none"
              stroke="#8e8e93"
              strokeWidth="1.5"
            />
          </g>
          <path
            id="Path_9018"
            data-name="Path 9018"
            d="M3314.131,3018.553h17.076"
            transform="translate(-2951.405 -2730.295)"
            fill="none"
            stroke="#8e8e93"
            strokeWidth="1.5"
          />
          <path
            id="Path_9019"
            data-name="Path 9019"
            d="M3314.131,3018.553h17.076"
            transform="translate(-2951.405 -2707.135)"
            fill="none"
            stroke="#8e8e93"
            strokeWidth="1.5"
          />
          <path
            id="Path_9020"
            data-name="Path 9020"
            d="M3314.131,3018.553h17.076"
            transform="translate(-2951.405 -2718.715)"
            fill="none"
            stroke="#8e8e93"
            strokeWidth="1.5"
          />
        </g>
        <rect
          id="Rectangle_24142"
          data-name="Rectangle 24142"
          width="33"
          height="32"
          transform="translate(344.802 280.944)"
          fill="none"
        />
      </g>
    </svg>
  );
};
